module.exports = __webpack_public_path__ + "img/vionic-mcpoil.ef9bac8f.png";